import { SitkaModule } from "olio-sitka"
import { call, put, select } from "redux-saga/effects"
import * as client from "../../api/client"
import { sortAuthTokens } from "../../util/oauth_utils"
import { makeToast } from "../../util/toast_util"

export default class OAuthModule extends SitkaModule {
    moduleName = "oauth"
    defaultState = {
        oAuthTokens: {
            items: {},
            sort: [],
            outsideAccessTokensSort: [],
            systemAccessTokensSort: [],
        },
    }

    constructor() {
        super()
        this.updateState = this.updateState.bind(this)
    }

    *handleIngressOAuthTokens(oAuthTokens = []) {
        const tokens = sortAuthTokens(oAuthTokens)
        yield call(this.updateState, { oAuthTokens: { ...tokens } })
    }

    *handleNewOAuthTokenSummary(oauthTokenSummary) {
        // todo: make this generic
        const { service, id } = oauthTokenSummary
        if (service === "google") {
            yield call(this.modules.googleCalendarConfigs.handleNewGoogleToken, id)
        }
        if (service === "zoom") {
            yield call(this.modules.zoomConfigs.handleNewZoomToken, id)
        }
    }

    *handleStartOAuth(oauthPopup, service) {
        const resp = yield call(client.getOAuthAuthorizationUrl, {
            service,
        })
        oauthPopup.location = resp.iframeSrc

        const listener = ({ data, origin }) => {
            window.removeEventListener("message", listener)
            if (Array.isArray(data) && data.indexOf("success") < 0) {
                /* eslint-disable no-console */
                console.log("Failed")
            } else {
                console.log("Success")
            }

            oauthPopup.close()
        }
        window.addEventListener("message", listener)
    }

    *handleRevokeOAuthToken(oAuthTokenId) {
        try {
            const successMsg = "Authorization has been revoked"
            const ind = "success"

            yield call(client.revokeOAuthToken, oAuthTokenId)
            yield call(makeToast, successMsg, ind)
        } catch (e) {
            const errorMsg =
                "Something went wrong removing this authorization.  Please try again."
            yield call(makeToast, errorMsg, "danger")
        }
        yield call(this.handleFetchTokens)
    }

    *handleFetchTokens() {
        try {
            const response = yield call(client.getOAuthTokens)
            yield call(this.handleIngressOAuthTokens, response)
        } catch (e) {
            const errorMsg =
                "Something went wrong retrieving your tokens.  Please try again."
            yield call(makeToast, errorMsg, "danger")
        }
    }

    *updateState(newState) {
        yield put(
            this.setState({
                ...(yield select(this.getCurrentState)),
                ...newState,
            }),
        )
    }

    getCurrentState(state) {
        return state.oauth
    }
}



// WEBPACK FOOTER //
// ./src/redux/modules/oauth.js